import { useEffect, useState, type FunctionComponent, } from "react";
import { SectionHeading, } from "@components";
import { ValueTile, } from "@bracket/react-value-tile";
import { Input, } from "@bracket/react-input";
import { Table, } from "@bracket/react-table";
import { usePointsStore, } from "@stores/points";
import { Loader, } from "@bracket/react-loader";
import moment from "moment";

import { ReferFriend, } from "./ReferFriend";

import "./Referrals.scss";



export declare type ReferralsProps = {

};


export const Referrals: FunctionComponent<ReferralsProps> = ({

}) => {

	const {
		initialized,
		initializing,
		initialize,
		initializedForUser,
		leaderboard,
		ref_search_needle,
		onReferralSearchUpdate,
		clearReferralSearch,
		referral_points_earned,
		referrals,
		referrals_reduced,
	} = usePointsStore();

	const classes = () => ["referrals"].join(" ");
	const referralDeadline = moment("20240802 1200").isBefore(moment());

	useEffect(() => {
		if (!initialized && !initializing) {
			(async () => {
				await initialize();
			})();
		}
		return () => {
			clearReferralSearch();
		}
	}, []);

	if (!initialized || !leaderboard) return <div className="loading"><Loader /></div>;

	return (
		<section className={classes()}>
			<SectionHeading name="Referrals">
				{/* <p className="stake-blurb">Earn <a href="#">ETH rewards</a> + <a href="#">Bracket Points</a> + <a href="#">Supported LRT Points</a> when you stake.</p> */}
			</SectionHeading>
			<ReferFriend />
			<div className="tiles">
				<ValueTile label="referral points earned" value={referral_points_earned} format="points" />
				<ValueTile label="wallets referred" value={referrals.length} format="number" />
				<ValueTile label="referral boost" value="20%" format="none" />
			</div>
			<div className="info">
				<p>Expect 24hrs before for each [BARS] update from referrals.</p>
			</div>
			<div className="search">
				<Input
					value={ref_search_needle || ""}
					onChange={onReferralSearchUpdate}
					width="20rem"
					placeholder="Search"
					icon="EyeGlass"
					iconProps={{ style: { height: "1rem", fill: "#aaaca7", paddingRight: "0.5rem", } }}
				/>
			</div>
			{
				!referralDeadline && (!referrals || !referrals.length) ?
					(
						<div className="data-alert">
							<p>Referral data will begin to show August 2nd</p>
						</div>
					)
					:
					(
						<Table
							data={referrals_reduced || referrals || []}
							keys={["address", "tvl_points",]}
							formats={{
								tvl_points: (v) => {
									v = typeof v === "number" ? v : Number.parseFloat(v);
									return Intl.NumberFormat("en-us").format(Math.round(v));
								},
								address: (v) => {
									v = typeof v === "string" ? v : v.toString();
									return `${v.slice(0, 4)}...${v.slice(v.length - 6, v.length)}`;
								}
							}}
							titles={["Referred", "TVL Points",]}
							rows={20}
							noRowsMessage="Refer your friends for a 20% boost" />
					)
			}
		</section>
	);

}
